import { Component } from '@angular/core';
import { NgForOf } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { FirstCasePipe } from '@shared/pipes/first-case.pipe';
import { Toast } from '@shared/interfaces/toast';
import { StateType } from '@shared/enums/state-type';
import { ToastService } from '@shared/services/toast.service';

@Component({
  selector: 'app-toast',
  imports: [FirstCasePipe, NgForOf],
  templateUrl: './toast.component.html',
  animations: [
    trigger('open', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(0.5rem)',
        }),
        animate(
          '300ms',
          style({
            opacity: 1,
            transform: 'translateY(0)',
          })
        ),
      ]),
      transition(':leave', [
        style({
          opacity: 1,
          transform: 'translateY(0)',
        }),
        animate(
          '100ms',
          style({
            opacity: 0,
            transform: 'translateY(0.5rem)',
          })
        ),
      ]),
    ]),
  ],
})
export class ToastComponent {
  toasts!: Toast[];
  protected readonly StateType = StateType;

  constructor(private toastService: ToastService) {
    this.toastService.toasts$.subscribe((toasts) => {
      this.toasts = toasts;
    });
  }
}
